function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck

import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import moment from "moment";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
import { toast } from "react-toastify";
// Customizable Area End

export const configJSON = require("./config");
export default class Settings2Controller extends BlockComponent {
  // Customizable Area Start

  // Customizable Area End

  constructor(props) {
    super(props);
    _defineProperty(this, "updateUsersLocalObj", newUserInfo => {
      var _newUserInfo$attribut;
      // this.setState({})
      let userInformation = localStorage.getItem('userInfo');
      userInformation = JSON.parse(userInformation);
      userInformation.data.attributes.photo = newUserInfo === null || newUserInfo === void 0 || (_newUserInfo$attribut = newUserInfo.attributes) === null || _newUserInfo$attribut === void 0 ? void 0 : _newUserInfo$attribut.photo;
      localStorage.setItem("userInfo", JSON.stringify(userInformation));
      window.location.reload();
    });
    _defineProperty(this, "showErrorToast", resObj => {
      if (resObj.message) {
        resObj.status !== 200 ? toast.error(resObj.message) : toast.success(resObj.message);
      }
    });
    _defineProperty(this, "txtInputWebProps", {
      onChangeText: text => {
        this.setState({
          txtInputValue: text
        });
      },
      secureTextEntry: false
    });
    _defineProperty(this, "txtInputMobileProps", _objectSpread(_objectSpread({}, this.txtInputWebProps), {}, {
      autoCompleteType: "email",
      keyboardType: "email-address"
    }));
    _defineProperty(this, "txtInputProps", this.isPlatformWeb() ? this.txtInputWebProps : this.txtInputMobileProps);
    _defineProperty(this, "btnShowHideProps", {
      onPress: () => {
        this.setState({
          enableField: !this.state.enableField
        });
        this.txtInputProps.secureTextEntry = !this.state.enableField;
        this.btnShowHideImageProps.source = this.txtInputProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible;
      }
    });
    _defineProperty(this, "btnShowHideImageProps", {
      source: this.txtInputProps.secureTextEntry ? imgPasswordVisible : imgPasswordInVisible
    });
    _defineProperty(this, "btnExampleProps", {
      onPress: () => this.doButtonPressed()
    });
    _defineProperty(this, "getUserProfile", () => {
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.getUserProfileApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.getUserProfileApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiGetType);
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleNewPasswordChange", event => {
      if (event.target.value !== "") {
        if (event.target.value === this.state.confirmPassword) {
          this.setState({
            newPassword: event.target.value,
            isNewPasswordValid: true,
            newPasswordErrorMessage: "",
            isConfirmPasswordValid: true,
            confirmPasswordErrorMessage: ""
          });
        } else {
          this.setState({
            newPassword: event.target.value,
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Password Does not Match"
          });
        }
      } else {
        this.setState({
          newPassword: "",
          isNewPasswordValid: false,
          newPasswordErrorMessage: "Field Cannot be blank."
        });
      }
    });
    _defineProperty(this, "handleConfirmPasswordChange", event => {
      if (event.target.value !== "") {
        if (this.state.newPassword == event.target.value) {
          this.setState({
            confirmPassword: event.target.value,
            isConfirmPasswordValid: true,
            confirmPasswordErrorMessage: ""
          });
        } else {
          this.setState({
            confirmPassword: event.target.value,
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Password Does not Match"
          });
        }
      } else {
        this.setState({
          confirmPassword: "",
          isConfirmPasswordValid: false,
          confirmPasswordErrorMessage: "Field cannot be blank."
        });
      }
    });
    _defineProperty(this, "handleResetPasswordClick", () => {
      if (this.state.newPassword !== "" && this.state.confirmPassword !== "" && this.state.isNewPasswordValid && this.state.isConfirmPasswordValid) {
        this.resetPassword();
      } else {
        if (this.state.newPassword !== this.state.confirmPassword) {
          this.setState({
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Password does not match"
          });
        }
        if (this.state.newPassword == "") {
          this.setState({
            isNewPasswordValid: false,
            newPasswordErrorMessage: "Field cannot be blank."
          });
        }
        if (this.state.confirmPassword == "") {
          this.setState({
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Field cannot be blank."
          });
        }
      }
    });
    _defineProperty(this, "resetPassword", () => {
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.resetPasswordApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.resetPasswordApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const httpBody = {
        data: {
          new_password: this.state.newPassword
        }
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiPutType);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleFileChange", acceptedFiles => {
      // console.log(acceptedFiles[0], "acceptedFiles[0].size", acceptedFiles[0].size / 1024 / 1024)
      if (acceptedFiles[0].size / 1024 / 1024 <= 1) {
        this.setState({
          file: acceptedFiles
        }, () => {
          this.setState({
            loading: true
          });
          this.uploadProfileImage(acceptedFiles);
        });
      } else {
        toast.error('File size cannot exceed 1mb');
      }
    });
    _defineProperty(this, "uploadProfileImage", file => {
      const header = {
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.uploadProfileImageApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.uploadPhotoApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      var bodyFormData = new FormData();
      bodyFormData.append("image", file[0]);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiPutType);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), bodyFormData);
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "deleteProfileImage", () => {
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.deleteProfileImageApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.removePhotoApiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiPutType);
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleCloseDialog", () => {
      this.setState({
        openDialog: !this.state.openDialog
      });
    });
    _defineProperty(this, "handleNotificationCheckbox", event => {
      let params = "?".concat(event.target.name, "=").concat(event.target.checked);
      this.updateNotificationSettings(params);
    });
    _defineProperty(this, "updateNotificationSettings", type => {
      const header = {
        "Content-Type": configJSON.validationApiContentType,
        token: localStorage.getItem("token")
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.updateNotificationApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), "".concat(configJSON.updateNotificationApiEndPoint).concat(type));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiPutType);
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.AccoutLoginSuccess), getName(MessageEnum.RestAPIResponceMessage)
    // Customizable Area Start
    // Customizable Area End
    ];
    this.state = {
      txtInputValue: "",
      txtSavedValue: "A",
      enableField: false,
      // Customizable Area Start
      newPassword: "",
      confirmPassword: "",
      isNewPasswordValid: true,
      isConfirmPasswordValid: true,
      newPasswordErrorMessage: "",
      confirmPasswordErrorMessage: "",
      file: null,
      userData: null,
      loading: true,
      openDialog: false,
      pushNotification: false,
      enable_load_limit: false,
      enableFlowLimit: false,
      targetNotify: false,
      updateLocalStorageProfile: false
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }
  async receive(from, message) {
    runEngine.debugLog("Message Recived", message);
    if (message.id === getName(MessageEnum.AccoutLoginSuccess)) {
      let value = message.getData(getName(MessageEnum.AuthTokenDataMessage));
      this.showAlert("Change Value", "From: " + this.state.txtSavedValue + " To: " + value);
      this.setState({
        txtSavedValue: value
      });
    }

    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId == this.resetPasswordApiCallId) {
        if (responseJson.data) {
          toast.success("Password updated successfully.");
        } else if (responseJson.errors) {
          if (responseJson.errors.length !== 0) {
            if (responseJson.errors[0].token) {
              //this.parseApiCatchErrorResponse(responseJson.errors[0].token);
              toast.error(responseJson.errors[0].token);
            } else if (responseJson.errors[0].profile) {
              // this.parseApiCatchErrorResponse(responseJson.errors[0].password);
              toast.error(responseJson.errors[0].profile);
            }
          }
        }
      } else if (apiRequestCallId === this.uploadProfileImageApiCallId) {
        if (responseJson.data && responseJson.meta) {
          if (Object.keys(responseJson.data).length !== 0) {
            if (responseJson.meta.message) {
              this.setState({
                updateLocalStorageProfile: true
              });
              toast.success(responseJson.meta.message);
              this.getUserProfile();
            }
          }
        } else {
          this.setState({
            loading: false
          });
          if (responseJson.message) {
            this.showErrorToast(responseJson);
          } else {
            toast.error("Something went wrong.");
          }
        }
      } else if (apiRequestCallId === this.getUserProfileApiCallId) {
        if (responseJson.data) {
          if (Object.keys(responseJson.data).length !== 0) {
            var _usersData$attributes, _usersData$attributes2;
            const usersData = responseJson.data;
            if (this.state.updateLocalStorageProfile) {
              this.updateUsersLocalObj(responseJson.data);
            }
            if (usersData !== null && usersData !== void 0 && (_usersData$attributes = usersData.attributes) !== null && _usersData$attributes !== void 0 && _usersData$attributes.activation_date) {
              const activatedDate = new Date(usersData.attributes.activation_date);
              usersData.attributes.activation_date = moment(activatedDate).format("DD-MM-YYYY");
            }
            if (usersData !== null && usersData !== void 0 && (_usersData$attributes2 = usersData.attributes) !== null && _usersData$attributes2 !== void 0 && _usersData$attributes2.renewal_date) {
              const activatedDate = new Date(usersData.attributes.renewal_date);
              usersData.attributes.renewal_date = moment(activatedDate).format("DD-MM-YYYY");
            }
            this.setState({
              userData: usersData,
              pushNotification: responseJson.data.attributes.enable_notification,
              enable_load_limit: responseJson.data.attributes.enable_load_limit,
              enableFlowLimit: responseJson.data.attributes.enable_flow_limit,
              targetNotify: responseJson.data.attributes.enable_target_complete,
              loading: false
            });
          } else {
            this.setState({
              loading: false
            });
          }
        }
      } else if (apiRequestCallId === this.deleteProfileImageApiCallId) {
        if (responseJson.data) {
          this.setState({
            updateLocalStorageProfile: true
          });
          toast.success("Image deleted successfully");
          this.handleCloseDialog();
          this.getUserProfile();
        } else {
          if (responseJson.message) {
            this.showErrorToast(responseJson);
          } else {
            toast.error("Something went wrong.");
          }
          this.handleCloseDialog();
        }
      } else if (apiRequestCallId === this.updateNotificationApiCallId) {
        console.log("updated", responseJson);
        if (responseJson) {
          if (responseJson.message) {
            this.showErrorToast(responseJson);
          } else {
            if (Object.keys(responseJson).length !== 0) {
              this.setState({
                pushNotification: responseJson.enable_notification,
                enableFlowLimit: responseJson.enable_flow_limit,
                enable_load_limit: responseJson.enable_load_limit,
                targetNotify: responseJson.enable_target_complete,
                loading: false
              });
            }
            toast.success("Changes updated successfully");
          }
        } else {
          toast.error("Something went wrong.");
        }
        // this.getUserProfile();
      }
    }
    // Customizable Area End
  }
  doButtonPressed() {
    let msg = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.txtInputValue);
    this.send(msg);
  }

  // Customizable Area Start

  async componentDidMount() {
    this.getUserProfile();
  }

  // Customizable Area End
}